import { useBoolean } from 'ahooks'
import { Button, Typography } from 'antd'

import { createWithDrawApplyApi } from '@eastcoal/api/finance/withdrawApply/createWithDrawApply'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudModalForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { InputNumber } from '@eastcoal/formily/components/InputNumber'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { useForm } from '@eastcoal/formily/exports/react'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { BankAccountSelect } from '@eastcoal/shared/@formily/BankAccountSelect'

import { useAccountStatisticContext } from '../../hooks/useContext'

const ActiveBalanceTip = () => {
  const form = useForm()

  return (
    <div>
      当前账户可用余额：
      <Typography.Text strong type='danger'>
        {form.values.activeBalance}
      </Typography.Text>
    </div>
  )
}

const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'memberId',
    'x-display': 'hidden'
  },
  {
    type: 'string',
    name: 'memberType',
    'x-display': 'hidden'
  },
  {
    type: 'string',
    name: 'memberName',
    required: true,
    title: '收款方',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-component-props': {
      disabled: true
    }
  },
  {
    type: 'object',
    name: '{ bankAccount, bankName: openBank, bankBranch }',
    title: '银行账户',
    required: true,
    'x-decorator': FormItem,
    'x-component': BankAccountSelect,
    'x-component-props': {
      memberId: '{{ $values.memberId }}'
    }
  },
  {
    type: 'number',
    name: 'activeBalance',
    title: '可用余额',
    'x-display': 'hidden'
  },
  {
    type: 'number',
    name: 'amount',
    title: '提现金额',
    required: true,
    'x-decorator': FormItem,
    'x-decorator-props': {
      feedbackText: <ActiveBalanceTip />
    },
    'x-component': InputNumber,
    'x-component-props': {
      min: 0,
      max: '{{ $values.activeBalance }}'
    }
  }
]

export const AccountStatisticWithdrawButton = () => {
  const [open, openActions] = useBoolean(false)

  const member = useAuthStore(state => state.member)
  const { data, refreshAsync } = useAccountStatisticContext()

  const { message } = useFeedback()
  const form = useCreationForm({
    initialValues: {
      memberType: member.type,
      memberName: member.name,
      memberId: member.id,
      activeBalance: data?.activeBalance ?? 0,
      balance: data?.balance ?? 0
    }
  })

  const handleSubmitSuccess = () => {
    message.success('提现成功')
    openActions.setFalse()
    refreshAsync()
    form.reset('*')
  }

  const applying = !!data?.unfinishedWithdrawApply

  return (
    <>
      <CrudModalForm
        createApi={createWithDrawApplyApi}
        form={form}
        mode={FormMode.CREATE}
        name='withdrawalForm'
        open={open}
        schema={schema}
        size={480}
        title='申请提现'
        actions={[
          <CancelButton key='cancelButton' />,
          <SubmitButton key='submitButton' />
        ]}
        onOpenChange={openActions.set}
        onSuccess={handleSubmitSuccess}
      />
      <Button
        ghost
        disabled={applying}
        size='small'
        type='primary'
        onClick={openActions.setTrue}
      >
        {applying ? '提现中' : '申请提现'}
      </Button>
    </>
  )
}
